<p>Sorry to stop you, but it looks like your computer time is off. Due to the time limits in Exam Coach, your computer time has to be right.</p>
<p>Please fix your time and reload the page to access Exam Coach. <em>You may have to exit and reload your browser to pick up the new time.</em></p>
<ng-container *ngIf="clientTime">
    <h4>Your computer time</h4>
    {{clientTime}}
    <br /><br />
    <h4>Our current time</h4>
    {{serverTime}}
</ng-container>